export default "__VITE_ASSET__qK1XmL$M__";